import React, { useState, useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import useApi from "../../hooks/useApi";

import Loader from "../../Components/Loader";

import { ReactComponent as Email } from "../../static/images/email.svg";
import { ReactComponent as Dial } from "../../static/images/dial-icon.svg";
import { ReactComponent as User } from "../../static/images/single_schedule.svg";
import "./style.scss";

const Customers = () => {
  const [customersData, setCustomersData] = useState([]);
  const [checkcustomersData, setCheckCustomersData] = useState([]);

  const { get, loading } = useApi();
  const customersRef = useRef([]);
  const { t } = useTranslation();

  const getCustomers = async (buid) => {
    try {
      const data = await get(`/BusinessAccount/${buid}/Customers`);

      const uniqueById = Object.values(
        data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
      );

      customersRef.current = uniqueById;

      setCustomersData(uniqueById);
      setCheckCustomersData(data);
    } catch (err) {}
  };

  const filterCustomers = (value) => {
    setCustomersData(
      customersRef.current.filter((userName) =>
        userName.name.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };

  useEffect(() => {
    const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
    const encodedToken = jwtDecode(ps10005000);

    getCustomers(encodedToken.buid);
  }, []);

  return (
    <div className="customers">
      {checkcustomersData.length ? (
        <ul>
          <h1>{t("active_customers")}</h1>
          <input
            type="text"
            placeholder={t("customer_name_search")}
            onChange={(e) => {
              filterCustomers(e.target.value);
            }}
          />
          {customersData.map((item, index) => {
            return (
              <li key={item.id}>
                <div className="customer-info">
                  <div className="customer-name">
                    {item.profileUrl ? (
                      <img src={item?.profileUrl} alt="image" />
                    ) : (
                      <User />
                    )}
                    <span>{item.name}</span>
                  </div>
                  <div className="customer-number">
                    <a href={`tel:${item.contactMSISDN}`}>
                      {"+" + item.contactMSISDN}
                    </a>
                    <Dial />
                  </div>
                  <div className="customer-email">
                    <a href={`mailto:${item.contactEmail}`}>
                      {item.contactEmail}
                    </a>
                    <Email />
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <h1 className="empty-customers">{t("empty_customers")}</h1>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default React.memo(Customers);
